export const TOKEN_PACKAGE_PRICES = {
	pl: {
		basic: '59.97 PLN',
		pro: '119.97 PLN',
		premium: '179.97 PLN',
	},
	en: {
		basic: '59.97 PLN',
		pro: '119.97 PLN',
		premium: '179.97 PLN',
	},
	de: {
		basic: '14.99 €',
		pro: '29.99 €',
		premium: '44.99 €',
	},
	cs: {
		basic: '349 Kč',
		pro: '699 Kč',
		premium: '1090 Kč',
	},
};
